(() => {
  if (window.__mdaOfferReady) return;
  window.__mdaOfferReady = true;

  const core = window.MdaOfferCore;
  if (!core) return;

  const KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  const RETURNING_KEY = 'mda-hol26-nc-returning';
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const gate = () => document.querySelector('[data-mda-offer-gate]');

  function pick(name) {
    try {
      return window[name];
    } catch (e) {
      return null;
    }
  }

  function storeStamp() {
    const sched = window.MdaSchedule;
    if (!sched) return null;
    const config = window.MDA_SCHEDULE || {};
    const shopify = window.Shopify || {};
    return (
      sched.previewNow({
        search: window.location.search,
        designMode: !!shopify.designMode,
        isLive: !!(shopify.theme && shopify.theme.role === 'main'),
        settingNow: config.previewNow || ''
      }) || sched.nowStamp(new Date(), config.tz || 'America/New_York')
    );
  }

  function readReturning() {
    try {
      return pick('sessionStorage').getItem(RETURNING_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function writeReturning(email) {
    try {
      const s = pick('sessionStorage');
      if (email) s.setItem(RETURNING_KEY, email);
      else s.removeItem(RETURNING_KEY);
    } catch (e) {}
  }

  const model = { unlock: null, returningEmail: '' };

  function currentState() {
    return core.pageState(model.unlock, !!model.returningEmail);
  }

  function setText(el, text) {
    if (el) el.textContent = text;
  }

  const heroOriginal = new Map();

  function swapHero(back) {
    const hero = document.querySelector('.mda-offer-hero');
    if (!hero) return;
    const d = hero.dataset;
    const slots = [
      ['[data-mda-hero-tag]', d.returningTag],
      ['[data-mda-hero-heading]', d.returningHeading],
      ['[data-mda-hero-lead]', d.returningLead],
      ['[data-mda-hero-body]', d.returningBody]
    ];
    slots.forEach(([selector, returningText]) => {
      const el = hero.querySelector(selector);
      if (!el) return;
      if (!heroOriginal.has(selector)) heroOriginal.set(selector, el.innerHTML);
      if (!back) {
        el.innerHTML = heroOriginal.get(selector);
      } else if (returningText) {
        el.textContent = returningText;
      }
    });
    const terms = hero.querySelector('[data-mda-hero-terms]');
    if (terms) terms.hidden = back;
  }

  function renderGate(state) {
    swapHero(state === 'returning');
    const g = gate();
    if (!g) return;
    g.dataset.state = state;
    g.querySelectorAll('[data-mda-gate-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.mdaGatePanel !== state;
    });
    const email = state === 'new' ? model.unlock.email : model.returningEmail;
    g.querySelectorAll('[data-mda-email]').forEach((el) => setText(el, email || ''));
  }

  function renderBundles(state) {
    document.querySelectorAll('[data-mda-offer-bundles]').forEach((section) => {
      section.dataset.state = state;
      const d = section.dataset;
      const back = state === 'returning';
      setText(section.querySelector('[data-mda-offer-heading]'), back ? d.returningHeading : d.heading);
      setText(section.querySelector('[data-mda-offer-subheading]'), back ? d.returningSubheading : d.subheading);
      section.querySelectorAll('[data-mda-when]').forEach((el) => {
        el.hidden = el.dataset.mdaWhen.split(' ').indexOf(state) === -1;
      });
      section.querySelectorAll('[data-mda-card-message]').forEach((msg) => {
        msg.hidden = true;
      });
    });
  }

  function render() {
    const state = currentState();
    renderGate(state);
    renderBundles(state);
  }

  function showGateMessage(kind, form) {
    const g = gate();
    const main = g && g.querySelector('[data-mda-gate-message]');
    const msg = (form && form.querySelector('[data-mda-gate-message]')) || main;
    const input = (form && form.querySelector('[data-mda-gate-email]')) || (g && g.querySelector('[data-mda-gate-email]'));
    if (!msg) return;
    if (!kind) {
      msg.hidden = true;
      msg.textContent = '';
      if (input) input.removeAttribute('aria-invalid');
      return;
    }
    const texts = (main || msg).dataset;
    const key = kind === 'rate_limited' ? 'rateLimited' : kind;
    msg.textContent = texts[key] || texts.error || '';
    msg.hidden = false;
    if (input) input.setAttribute('aria-invalid', kind === 'invalid' ? 'true' : 'false');
  }

  async function subscribeKlaviyo(email) {
    const g = gate();
    if (!g) return;
    const companyId = g.dataset.companyId;
    const listId = g.dataset.listId;
    if (!companyId || !listId) {
      console.error('[mda-offer] Missing Klaviyo company ID or list ID. Set them in theme settings or the section.');
      return;
    }
    try {
      await fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/json',
          revision: g.dataset.revision || '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: g.dataset.customSource || 'Holiday new-customer page',
              profile: { data: { type: 'profile', attributes: { email } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      });
    } catch (e) {}
  }

  function usableUnlock(body) {
    return (
      body &&
      body.codes &&
      typeof body.codes === 'object' &&
      Object.keys(body.codes).length > 0 &&
      typeof body.end === 'string'
    );
  }

  // Without a gate Worker, the codes come from the bundle cards and the end from the hero schedule.
  function pageUnlock() {
    const codes = {};
    document.querySelectorAll('[data-mda-offer-card][data-mda-offer-code]').forEach((card) => {
      codes[card.dataset.mdaOfferHandle] = card.dataset.mdaOfferCode;
    });
    const hero = document.querySelector('.mda-offer-hero[data-mda-end], [data-mda-offer-gate][data-mda-end], [data-mda-end]');
    const end = hero && hero.dataset.mdaEnd;
    if (!Object.keys(codes).length || !end) return null;
    return { codes, end };
  }

  async function submitGate(form) {
    const input = form.querySelector('[data-mda-gate-email]');
    const button = form.querySelector('[data-mda-gate-submit]');
    const email = (input.value || '').trim();
    showGateMessage(null, form);
    if (!EMAIL_RE.test(email)) {
      showGateMessage('invalid', form);
      input.focus();
      return;
    }
    const endpoint = (window.MDA_SCHEDULE || {}).gateEndpoint;
    if (!endpoint) {
      const local = pageUnlock();
      if (!local) {
        showGateMessage('error', form);
        return;
      }
      button.disabled = true;
      try {
        model.unlock = { email, codes: local.codes, end: local.end };
        model.returningEmail = '';
        core.saveUnlock(pick('localStorage'), model.unlock);
        writeReturning('');
        subscribeKlaviyo(email);
        const failedHandles = await applyToCart(false);
        render();
        if (failedHandles) showCardErrors(failedHandles);
      } finally {
        button.disabled = false;
      }
      return;
    }
    button.disabled = true;
    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      let body = null;
      try {
        body = await res.json();
      } catch (e) {}
      const status = body && body.status;
      if (res.ok && status === 'new' && usableUnlock(body)) {
        model.unlock = { email, codes: body.codes, end: body.end };
        model.returningEmail = '';
        core.saveUnlock(pick('localStorage'), model.unlock);
        writeReturning('');
        subscribeKlaviyo(email);
        const failedHandles = await applyToCart(false);
        render();
        if (failedHandles) showCardErrors(failedHandles);
      } else if (res.ok && status === 'returning') {
        const previous = model.unlock;
        model.unlock = null;
        core.clearUnlock(pick('localStorage'));
        model.returningEmail = email;
        writeReturning(email);
        render();
        dropNcCodes(previous);
      } else if (status === 'invalid') {
        showGateMessage('invalid', form);
      } else if (status === 'closed' || status === 'rate_limited') {
        showGateMessage(status, form);
      } else {
        showGateMessage('error', form);
      }
    } catch (e) {
      showGateMessage('error', form);
    } finally {
      button.disabled = false;
    }
  }

  function resetGate() {
    const previous = model.unlock;
    model.unlock = null;
    model.returningEmail = '';
    core.clearUnlock(pick('localStorage'));
    writeReturning('');
    const input = gate() && gate().querySelector('[data-mda-gate-email]');
    if (input) input.value = '';
    showGateMessage(null);
    render();
    focusGate();
    dropNcCodes(previous);
  }

  function focusGate() {
    const g = gate();
    if (!g) return;
    const input = g.querySelector('[data-mda-gate-email]');
    g.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (input) input.focus({ preventScroll: true });
  }

  async function getJson(url, options) {
    const res = await fetch(url, options);
    if (!res.ok) throw new Error(url + ' ' + res.status);
    return res.json();
  }

  async function postDiscount(codes) {
    await getJson('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
  }

  async function applyCodesTo(cart) {
    if (!model.unlock) return false;
    const handles = (cart.items || []).map((item) => item.handle);
    const existing = core.appliedCodes(cart);
    const codes = core.codesForCart(handles, existing, model.unlock.codes);
    if (codes.length === 0 || core.sameCodes(existing, codes)) return false;
    await postDiscount(codes);
    return true;
  }

  function refreshDrawer(open) {
    if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    if (open) {
      if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
      else window.location.href = '/cart';
    }
  }

  async function applyToCart(open) {
    let cart = null;
    try {
      cart = await getJson('/cart.js', { headers: { Accept: 'application/json' } });
      const changed = await applyCodesTo(cart);
      if (changed) refreshDrawer(open);
      return null;
    } catch (e) {
      const bundles = cart && model.unlock ? (cart.items || []).map((item) => item.handle).filter((h) => h in model.unlock.codes) : [];
      return bundles;
    }
  }

  async function dropNcCodes(previous) {
    if (!previous) return;
    try {
      const cart = await getJson('/cart.js', { headers: { Accept: 'application/json' } });
      const existing = core.appliedCodes(cart);
      const kept = core.codesForCart([], existing, previous.codes);
      if (core.sameCodes(existing, kept)) return;
      await postDiscount(kept);
      refreshDrawer(false);
    } catch (e) {}
  }

  function showCardErrors(handles) {
    document.querySelectorAll('[data-mda-offer-card]').forEach((card) => {
      if (handles.indexOf(card.dataset.mdaOfferHandle) === -1) return;
      const msg = card.querySelector('[data-mda-card-message]');
      const section = card.closest('[data-mda-offer-bundles]');
      if (msg && section) {
        msg.textContent = section.dataset.error;
        msg.hidden = false;
      }
    });
  }

  async function addToCart(card, button) {
    const msg = card.querySelector('[data-mda-card-message]');
    const section = card.closest('[data-mda-offer-bundles]');
    if (msg) msg.hidden = true;
    button.disabled = true;
    try {
      await getJson('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(card.dataset.variantId), quantity: 1 }] })
      });
      const cart = await getJson('/cart.js', { headers: { Accept: 'application/json' } });
      await applyCodesTo(cart);
      const dialog = card.querySelector('dialog');
      if (dialog && dialog.open) dialog.close();
      refreshDrawer(true);
    } catch (e) {
      if (msg && section) {
        msg.textContent = section.dataset.error;
        msg.hidden = false;
      }
    } finally {
      button.disabled = false;
    }
  }

  function onClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const action = target.closest('[data-mda-offer-action]');
    if (action) {
      const card = action.closest('[data-mda-offer-card]');
      if (action.dataset.mdaOfferAction === 'add') {
        addToCart(card, action);
      } else {
        const dialog = action.closest('dialog');
        if (dialog && dialog.open) dialog.close();
        focusGate();
      }
      return;
    }

    const details = target.closest('[data-mda-offer-details]');
    if (details) {
      const dialog = document.getElementById(details.dataset.mdaOfferDetails);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const close = target.closest('[data-mda-offer-close]');
    if (close) {
      const dialog = close.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    if (target.matches && target.matches('dialog.mda-offer-modal')) {
      target.close();
      return;
    }

    if (target.closest('[data-mda-gate-reset]')) resetGate();
  }

  function onSubmit(event) {
    const form = event.target.closest && event.target.closest('[data-mda-gate-form]');
    if (!form) return;
    event.preventDefault();
    submitGate(form);
  }

  function init() {
    const stamp = storeStamp();
    model.unlock = stamp ? core.readUnlock(pick('localStorage'), stamp) : null;
    model.returningEmail = model.unlock ? '' : readReturning();
    render();
    if (model.unlock) applyToCart(false);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('submit', onSubmit);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
